import React, {FC, useEffect, useRef, useState} from 'react'
import Step1 from './steps/Step1'
import Step2 from './steps/Step2'
//import {Step3} from './steps/Step3'
//import {Step4} from './steps/Step4'
//import {Step5} from './steps/Step5'
import {KTIcon} from '../../../../_metronic/helpers'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import {Form, Formik, FormikValues} from 'formik'
import { createAccountSchemas, ICreateAccount, inits } from '../../wizards/components/CreateAccountWizardHelper'
import { Resumensolicitud } from './components/Modalversion'

type VPN= {
  Cantidad:string,
  Connectcap:string,
  total:number
}

type Edge= {
  opcionEdge:string,
  cantidadedge:string,
  capacidadedge:string,
  totaledge:number
}

type VRFs={
  VRF_name:string,
}
type ID = undefined | null | number

type Resumen={
  cloud:string,
  tipo_locacion:string,
  continente:string,
  region:string,
  type_ctx:string,
  Throughput:string,
  listVPNcon:VPN[],
  listCloudConnIntra:Intraregion[],
  listCloudConnInter:InterRegion[],
  listCEdgeConn:Edge[],
  listVRF:VRFs[],
  Security:string[],
  Total_trhoug:number,
}
type ResumenOutbund={
  listEdgeOutbund:{},
  listInterOutbund:{},
  listIntraOutbund:{},
  llistVpnOutbund:{},
  total:number
}

type Intraregion ={
  CapacidadIntra:string,
  ConexionIntra:string,
  RegionIntra:string,
  availability:string,
}

type InterRegion ={
  CapacidadInterReg:string,
  ConexionInterReg:string,
  LocacionInter:string,
  ContinenteInterreg:string,
  ZonaInter:string, 
}

type VPNThorugput=
  {
    [clave: string]: any
  }

type IntraOutbund={
  [clave: string]: any
}

type InterOutbund={
  [clave: string]: any
}

type EdgeOutbund={
  [clave: string]: any

}

const SolicitarnuevoCTXh: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  //const [currentSchema, setCurrentSchema] = useState(createAccountSchemas[0])
  const [initValues] = useState<ICreateAccount>(inits)
  const [isSubmitButton, setSubmitButton] = useState(false)




////////////////////////////////////////////////
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }


  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
    setpaso(paso-1)

    //setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])

    {setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)}
  }

  const submitStep = (values: ICreateAccount, actions: FormikValues) => {
    if (!stepper.current) {
      return
    }

    

    if (stepper.current.currentStepIndex !== stepper.current.totalStepsNumber) {
      stepper.current.goNext()
      setpaso(paso+1)
    } else {
      setID(null)
      //stepper.current.goto(1)
      //setpaso(1)
    }


    setSubmitButton(stepper.current.currentStepIndex === stepper.current.totalStepsNumber)

    //setCurrentSchema(createAccountSchemas[stepper.current.currentStepIndex - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  /************************************************************/
  const [paso,setpaso]=useState(1)


  const [resumen,setresumen]=useState<Resumen>()
  const [listVpnOutbund,setlistVpnOutbund]= useState <VPNThorugput>({})
  const[listIntraOutbund,setlistIntraOutbund]= useState<IntraOutbund>({})
  const[listInterOutbund,setlistInterOutbund]= useState<InterOutbund>({})
  const [listEdgeOutbund,setlistEdgeOutbund]= useState<EdgeOutbund>({})
  const [counter, setCounter] = useState(0)

  const [ ID , setID]=useState<ID>(undefined)

  const[resumenOutbund,setresumenOutbund]= useState<ResumenOutbund[]|any>()
  useEffect( () => {
  
    setresumenOutbund({
      listEdgeOutbund:listEdgeOutbund,
      listIntraOutbund:listIntraOutbund,
      listInterOutbund:listInterOutbund,
      llistVpnOutbund:listVpnOutbund,
      total:counter

    }
  
    )
 
  }, [listVpnOutbund,listIntraOutbund,listInterOutbund,listEdgeOutbund])




  return (
    <div className='card'>
      <div className='card-body'>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column pt-15'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav mb-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Connectors</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Data Usage</h3>
            </div>


          </div>

          <Formik  initialValues={initValues} onSubmit={submitStep}>
            {() => (
              <Form className='mx-auto mw-800px w-100 pt-15 pb-10' id='kt_create_account_form'>
                <div className='current' data-kt-stepper-element='content'>
                  <Step1 paso={paso} set={setresumen}/>
                </div>
                
                <div data-kt-stepper-element='content'>
                  <Step2  info={resumen} listVpnOutbund={listVpnOutbund} setlistVpnOutbund={setlistVpnOutbund}
                  setlistIntraOutbund={setlistIntraOutbund} listIntraOutbund={listIntraOutbund}
                  setlistInterOutbund={setlistInterOutbund} listInterOutbund= {listInterOutbund}
                  setlistEdgeOutbund={setlistEdgeOutbund} listEdgeOutbund={listEdgeOutbund}
                  setCounter={setCounter} counter={counter}/>
                </div>


               

                <div className='d-flex flex-stack pt-15'>
                  <div className='mr-2'>
                    <button
                      onClick={prevStep}
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                    >
                      <KTIcon iconName='arrow-left' className='fs-4 me-1' />
                      Back
                    </button>
                  </div>
                  <div>
                    <button type='submit' className={`btn btn-primary ${resumen &&(resumen.Total_trhoug >Number(resumen.Throughput))? 'btn-danger':''}`} 
                    disabled={resumen? (resumen.Total_trhoug > Number(resumen.Throughput)):false} >
                      <span className='indicator-label'>
                        {!isSubmitButton &&  'Continue'}
                        {isSubmitButton && 'Submit'}
                        <KTIcon iconName='arrow-right' className='fs-3 ms-2 me-0' />
                      </span>
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        
      </div>
      {ID !== undefined && <Resumensolicitud setID={setID} id={ID} info={resumen} infostepdos={resumenOutbund} />}
    </div>
  )
}

export {SolicitarnuevoCTXh}

